import { CALENDLY_URL, WHATSAPP_NUMBER } from './chatLabels';

export function ChatHandoffBar({ labels, path, qualified, onHandoff }) {
  const topic = path === 'investment' ? labels.waInvest : labels.waTours;
  const waText = path ? labels.waText.replace('{path}', topic) : '';
  const waHref = `https://wa.me/${WHATSAPP_NUMBER}${waText ? `?text=${encodeURIComponent(waText)}` : ''}`;
  const showMore = Boolean(path) && qualified;

  return (
    <div className="chatbot-handoff" data-testid="chat-handoff-bar">
      <a href={waHref} target="_blank" rel="noopener noreferrer" className="chat-handoff-btn chat-handoff-wa" onClick={() => onHandoff('whatsapp')} data-testid="chat-handoff-whatsapp">
        <i className="fab fa-whatsapp" aria-hidden="true"></i> {labels.whatsapp}
      </a>
      {showMore && (
        <>
          <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="chat-handoff-btn" onClick={() => onHandoff('calendly')} data-testid="chat-handoff-calendly">
            <i className="far fa-calendar-check" aria-hidden="true"></i> {labels.calendly}
          </a>
          <button type="button" className="chat-handoff-btn" onClick={() => onHandoff('callback')} data-testid="chat-handoff-callback">
            <i className="fas fa-phone-alt" aria-hidden="true"></i> {labels.callback}
          </button>
        </>
      )}
    </div>
  );
}
